const listNamesConfig = {
  entityItemsNamePlural: "Media",
  areaAccessName: "MediaLibrary"
};

export default listNamesConfig;